<template>
    <div class="columns is-multiline">
        <div v-for="(category, categoryIndex) in categories" class="column is-half-tablet">
            <div class="document-category document-category--bg-green" @click="activateCategory(categoryIndex)">
                <img v-if="categoryIndex === activeCategoryIndex" src="/assets/web/images/checkbox-white-full.svg"
                     class="document-category-checkbox" :alt="category.name">
                <img v-else src="/assets/web/images/checkbox-white-empty.svg" class="document-category-checkbox"
                     :alt="category.name[lang]">
                {{ category.name[lang] }}
            </div>
        </div>
        <div class="column is-full">
            <div v-for="(category, categoryIndex) in categories" :class="{'FilesWrap-CategoryGroup__body': true,  'is-active' : activeCategoryIndex == categoryIndex}">
                <div class="FilesWrap">
                    <div class="FilesWrap-item"
                         v-for="(document, index) in category.documents.sort((a,b) => {return a.order - b.order;})">
                        <div class="columns is-multiline">
                            <div class="column is-2 has-text-centered">
                                <img src="/assets/web/images/icons/dokument.png" :alt="document.name" width="100">
                            </div>
                            <div class="column is-8">
                                <div class="FilesWrap-item__head">
                                    <h3>{{ document.name[lang] }}</h3>
                                    <span class="date-value">{{ document.file_date }}</span>
                                </div>

                                <p>{{ document.description[lang] }}</p>
                            </div>
                            <div class="column is-2 has-text-right">
                                <div class="FilesWrap-DownloadButton">
                                    <a class="button " :href="documentsDownloadRoute + '/' + document.uuid">{{ i18n.stiahnut }}</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        categories: Array,
        documentsDownloadRoute: String
    },
    data: function () {
        return {
            activeCategoryIndex: null,
	          lang: document.documentElement.lang,
            i18n: i18n
        };
    },
    mounted() {
    },
    methods: {
        activateCategory: function (index) {
            if (this.activeCategoryIndex == index)
                this.activeCategoryIndex = null;
            else
                this.activeCategoryIndex = index;
        }
    }
};
</script>
